import { Collapseable } from "components/UI/Collapseable/Collapseable";
import { FC } from "react";

import { ApiMethodForm } from "./ApiMethodForm";
import { StepForm } from "./StepForm";

import IntegrationData = App.Data.IntegrationData;
import IncomingPostbackDataOptional = App.Data.IncomingPostbackDataOptional;

interface ApiMethodPanelProps {
    integration?: IntegrationData;
    postback?: IncomingPostbackDataOptional;
    name: number;
    handleRemoveMethod: () => void;
    disabled: boolean;
}

export const ApiMethodPanel: FC<ApiMethodPanelProps> = ({ integration, name, handleRemoveMethod, disabled }) => {
    const leadFields = integration?.formFields ?? [];

    return (
        <Collapseable
            header={<StepForm name={name} handleRemoveMethod={handleRemoveMethod} disabled={disabled} />}
            collapsible={disabled ? "disabled" : "icon"}
            className={disabled ? "bg-neutral-100 opacity-45 p-1" : "bg-neutral-100 p-1"}
        >
            <ApiMethodForm leadFields={leadFields} name={name} />
        </Collapseable>
    );
};
